import { Injectable, signal } from '@angular/core';
import { CartItem } from '../models/cart-item.model';

const CART_KEY = 'cart';

@Injectable({ providedIn: 'root' })
export class CartService {
  items = signal<CartItem[]>(this.load());

  private load(): CartItem[] {
    try {
      return JSON.parse(localStorage.getItem(CART_KEY) ?? '[]');
    } catch {
      return [];
    }
  }

  private save(items: CartItem[]): void {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    this.items.set(items);
  }

  add(item: CartItem): void {
    const current = this.items();
    const index = current.findIndex(
      i => i.productId === item.productId &&
        JSON.stringify(i.filters) === JSON.stringify(item.filters)
    );

    if (index !== -1) {
      const updated = [...current];
      updated[index] = { ...updated[index], quantity: updated[index].quantity + item.quantity };
      this.save(updated);
    } else {
      this.save([...current, item]);
    }
  }

  remove(productId: number, filters: CartItem['filters']): void {
    this.save(this.items().filter(
      i => !(i.productId === productId && JSON.stringify(i.filters) === JSON.stringify(filters))
    ));
  }

  updatePrice(productId: number, filters: CartItem['filters'], priceUah: number, priceUahOld?: number): void {
    const updated = this.items().map(i =>
      i.productId === productId && JSON.stringify(i.filters) === JSON.stringify(filters)
        ? { ...i, priceUah, priceUahOld }
        : i
    );
    this.save(updated);
  }

  updateQuantity(productId: number, filters: CartItem['filters'], quantity: number): void {
    const updated = this.items().map(i =>
      i.productId === productId && JSON.stringify(i.filters) === JSON.stringify(filters)
        ? { ...i, quantity }
        : i
    );
    this.save(updated);
  }

  clear(): void {
    this.save([]);
  }

  get totalCount(): number {
    return this.items().reduce((sum, i) => sum + i.quantity, 0);
  }
}
